/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Box, Button, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { fieldSx } from "./index";

const API = "https://api.besteurogirls.com";
const RED = "#d4163c";
const PW_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const ResetPasswordPage: React.FC = () => {
  const token = (() => {
    try { return new URLSearchParams(window.location.search).get("token") || ""; } catch (e) { return ""; }
  })();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const prev = document.title;
    document.title = "Reset password | Best Euro Girls";
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => { document.title = prev; m.remove(); };
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    if (!PW_RULE.test(pw)) { setErr("Password: at least 8 characters, with uppercase, lowercase and a number."); return; }
    if (pw !== pw2) { setErr("The two passwords are not the same."); return; }
    setBusy(true);
    try {
      const res = await fetch(API + "/public/password/reset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password: pw }),
      });
      const data: any = await res.json().catch(() => ({}));
      if (res.ok && data.ok) { setDone(true); setBusy(false); return; }
      setErr((data && data.error && data.error.message) || "Could not change the password. Ask for a new link.");
    } catch (ex) {
      setErr("Could not change the password. Check your connection and try again.");
    }
    setBusy(false);
  };

  const eye = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton aria-label="Show or hide password" onClick={() => setShow(!show)} onMouseDown={(ev) => ev.preventDefault()} edge="end" sx={{ color: "rgba(255,255,255,.7)" }}>
          {show ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  };

  return (
    <Box sx={{ maxWidth: 420, mx: "auto", py: { xs: 3, md: 5 }, color: "#e8e8ec" }}>
      <Box sx={{ backgroundColor: "#1a1a20", border: "1px solid rgba(255,255,255,.08)", borderRadius: 2, p: { xs: 2.5, md: 3.5 } }}>
        <Typography component="h1" sx={{ color: "#fff", fontSize: { xs: 28, md: 32 }, fontWeight: 600, mb: 2 }}>
          New password
        </Typography>
        {done ? (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>Your password was changed. You can log in now.</Alert>
            <Button component={RouterLink} to="/login" variant="contained" fullWidth size="large"
              sx={{ backgroundColor: RED, fontWeight: 700, letterSpacing: ".06em", borderRadius: "10px", py: 1.25, "&:hover": { backgroundColor: "#a8102f" } }}>
              LOGIN
            </Button>
          </>
        ) : !token ? (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>This link is not valid. Ask for a new one.</Alert>
            <Button component={RouterLink} to="/login" sx={{ color: "rgba(255,255,255,.75)", textTransform: "none", textDecoration: "underline", px: 0 }}>
              Back to login
            </Button>
          </>
        ) : (
          <Box component="form" onSubmit={submit} noValidate sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField label="New password" type={show ? "text" : "password"} required value={pw} sx={fieldSx}
              helperText="At least 8 characters, with uppercase, lowercase and a number."
              FormHelperTextProps={{ sx: { color: "rgba(255,255,255,.55)" } }}
              inputProps={{ maxLength: 100, autoComplete: "new-password" }} onChange={(e) => setPw(e.target.value)} InputProps={eye} />
            <TextField label="Repeat new password" type={show ? "text" : "password"} required value={pw2} sx={fieldSx}
              inputProps={{ maxLength: 100, autoComplete: "new-password" }} onChange={(e) => setPw2(e.target.value)} />
            {err && <Alert severity="error">{err}</Alert>}
            <Button type="submit" variant="contained" size="large" disabled={busy || !pw || !pw2}
              sx={{ backgroundColor: RED, fontWeight: 700, letterSpacing: ".06em", borderRadius: "10px", py: 1.25, "&:hover": { backgroundColor: "#a8102f" }, "&.Mui-disabled": { backgroundColor: "rgba(212,22,60,.35)", color: "rgba(255,255,255,.6)" } }}>
              {busy ? "Please wait..." : "CHANGE PASSWORD"}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
